import { Component } from '@angular/core';
import {
  MAT_DIALOG_DATA, MatDialog,
  MatDialogConfig, MatDialogRef
} from '@angular/material/dialog';
import { getDevicePlatform } from 'helpers';

@Component({
  selector: 'app-pwa-dialog-component',
  templateUrl: './pwa-dialog.component.html',
})
export class PWADialogComponent {

  constructor(
    public _dialogRef: MatDialogRef<PWADialogComponent>
  ) { }

  close(data: any = null) {
    this._dialogRef.close(data);
  }

  isIOS() {
    const platform = getDevicePlatform();
    return platform === 'ios' ? true : false;
  }

  isAndroid() {
    const platform = getDevicePlatform();
    return platform === 'android' ? true : false;
  }

}
